module.exports = __webpack_public_path__ + "img/logo-192x192.d1a64822.png";